import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { OnOrbitActions } from "../../actions/on-orbit.actions";
import { OnOrbitOrderState } from "../../models/on-orbit/on-orbit-order-state";

const initialState: OnOrbitOrderState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(OnOrbitActions.order.getApi, (state) => ({ ...state, loading: true })),
	on(OnOrbitActions.order.getSuccess, (state, action) => {
		const newState = _.cloneDeep(state);
		if (!_.has(newState, "orderOnOrbits")) {
			newState.orderOnOrbits = action.orderOnOrbits;
		} else {
			_.forEach(_.keys(action.orderOnOrbits), (orderId) => {
				_.set(newState.orderOnOrbits, orderId, action.orderOnOrbits[orderId]);
			});
		}
		newState.loading = action.loading;
		return newState;
	}),
	on(OnOrbitActions.order.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	)
);

export function onOrbitOrderReducer(
	state: OnOrbitOrderState | undefined,
	action: Action
): OnOrbitOrderState {
	return reducer(state, action);
}
